<template>
  <div class="datos-generales-social" id="socialEvaluation">
    <el-col class="col">
      <div class="form">
        <el-container>
          <el-main>
            <el-form
              :model="form"
              ref="refId"
              :rules="rules"
              @presubmit.prevent
            >
              <div class="row-no-center" style="width:100%">
                <div style="flex: 1;">
                  <div>
                    <p class="label-style">DATOS GENERALES</p>
                    <el-form-item
                      prop="motivoEvaluacion"
                      style="width: 250px; margin-top:15px;"
                      label="Motivo de la Evaluación"
                    >
                      <el-input v-model="form.motivoEvaluacion" type="textarea"/>
                    </el-form-item>
                    <el-form-item
                      prop="residenceTimeAtTijuana"
                      style="width: 250px"
                      label="Tiempo de residencia en Tijuana"
                    >
                      <el-input v-model="form.residenceTimeAtTijuana" type="textarea"/>
                    </el-form-item>
                  </div>
                  <div>
                    <p class="label-style">LÍNEA DE BIENESTAR</p>
                    <div class="row-no-center" style="margin-top:15px;">
                      <el-form-item class="medium" prop="academicDegree" label="Escolaridad">
                        <el-select v-model="form.academicDegree">
                          <el-option
                            v-for="item in academicDegree"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        class="medium"
                        prop="houseCondition"
                        label="Condiciones de la vivienda"
                      >
                        <el-select v-model="form.houseCondition">
                          <el-option
                            v-for="item in houseCondition"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          />
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div>
                  <p class="label-style">CARACTERISTICAS DE LA VIVIENDA</p>
                  <div class="row-no-center" style="margin-top:15px;">
                    <el-form-item class="medium" prop="houseWalls" label="Paredes">
                      <el-select v-model="form.houseWalls">
                        <el-option
                          v-for="item in houseWalls"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item class="medium" prop="houseRoof" label="Techo">
                      <el-select v-model="form.houseRoof">
                        <el-option
                          v-for="item in houseRoof"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item class="medium" prop="houseFloor" label="Piso">
                      <el-select v-model="form.houseFloor">
                        <el-option
                          v-for="item in houseFloor"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                </div>
                <div class="file-container">
                  <div class="file" @click="docsVisible = true"/>
                  <p class="lbl1">Adjuntar Imagen / Documento</p>
                  <p class="lbl2">referencia del nivel socioeconómico del paciente</p>
                </div>
              </div>
              <div style="margin-top:20px;">
                <p class="label-style">CUARTOS DE LA VIVIENDA</p>
                <div class="row-no-center" style="margin-top:15px;">
                  <el-checkbox v-model="form.houseRoomsLivingRoom">Sala</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsDiningRoom">Comedor</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsKitchen">Cocina</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsBathroom">Baño</el-checkbox>
                  <el-checkbox v-model="houseRoomsBedroom">Recámara</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsStudyingRoom">Estudio</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsCourtyard">Patio</el-checkbox>
                  <el-checkbox v-model="form.houseRoomsOther">Otro</el-checkbox>
                </div>
                <bathroom
                  v-if="form.houseRoomsBathroom"
                  :idAppointment="idAppointment"
                />
                <el-form-item
                  class="medium"
                  prop="houseRoomsBedroom"
                  label="Cantidad de recámaras"
                  v-if="houseRoomsBedroom"
                >
                  <el-input-number v-model="form.houseRoomsBedroom" :min="1" />
                </el-form-item>
              </div>
              <div style="margin-top:20px;">
                <p class="label-style">SERVICIOS DE LA VIVIENDA</p>
                <div class="row-no-center" style="margin-top:15px;">
                  <el-checkbox v-model="form.serviceLight">
                    Instalación de luz
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceSewerSystem">
                    Drenaje y alcantarillado
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceCableTV">
                    Televisión por cable
                  </el-checkbox>
                  <el-checkbox v-model="form.servicePhone">
                    Teléfono fijo
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceInternet">
                    Internet
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceAsphaltStreet">
                    Pavimento en las calles
                  </el-checkbox>
                  <el-checkbox v-model="form.servicePublicWater">
                    Agua Pública
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceGaslp">
                    Gas LP
                  </el-checkbox>
                  <el-checkbox v-model="form.serviceOther">
                    Otro
                  </el-checkbox>
                </div>
              </div>
              <div style="margin-top:25px;">
                <p class="label-style">MUEBLES Y ELECTRODOMÉSTICOS</p>
                <div class="row-no-center" style="margin-top:15px;">
                  <el-checkbox v-model="form.houseStuffTV">
                    Televisión
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffFridge">
                    Refrigerador
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffStove">
                    Estufa
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffDishWasher">
                    Parrilla eléctrica
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffMicrowaveOven">
                    Horno de Microondas
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffBlender">
                    Licuadora
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffWashingMachine">
                    Lavadora
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffDryer">
                    Secadora
                  </el-checkbox>
                </div>
                <div class="row-no-center" style="margin-top:15px;">
                  <el-checkbox v-model="form.houseStuffComputer">
                    Computadora o Ipad</el-checkbox>
                  <el-checkbox v-model="form.houseStuffDiningRoomSet">
                    Comedor
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffLivingRoomSet">
                    Sala
                  </el-checkbox>
                  <el-checkbox v-model="form.houseStuffBedroomSet">
                    Recámara
                  </el-checkbox>
                </div>
              </div>
              <div style="margin-top:20px;">
                <p class="label-style" style="margin-bottom:10px;">CUENTA CON AUTO PROPIO</p>
                <div class="row-no-center">
                  <div class="addCar-container">
                    <div>
                      <el-button
                        icon="el-icon-plus"
                        type="primary"
                        circle
                        @click="addCar(num, numNewCar)"
                        />
                    </div>
                    <p>Agregar un automóvil</p>
                  </div>
                </div>
                <div class="cars-container">
                  <ul
                    class="row-no-center"
                    v-if="num > 0"
                    style="list-style:none;
                      display: flex;
                      flex-direction:row;
                      gap: 8px;
                      flex-wrap: wrap;"
                  >
                    <li v-for="(cars, idx) in car" :key="idx">
                      <div class="container-card-cars">
                        <label for="modelo">Modelo</label>
                        <input id="Modelo" v-model="cars.model">
                        <label for="Año">Año</label>
                        <input id="Año" v-model="cars.year">
                        <label for="cars">Placas</label>
                        <select
                          name="cars"
                          id="cars"
                          placeholder="Año"
                          v-model="cars.plates"
                        >
                          <option
                            value=""
                            disabled
                            selected
                            hidden
                          >
                            Seleccionar
                          </option>
                          <option
                            v-for="item in Placas"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </select>
                        <div class="btn-options">
                          <el-button
                            v-if="cars.id"
                            type="primary"
                            size="mini"
                            round
                            style="width:46%; height: 25px;"
                            icon="el-icon-refresh-right"
                            @click="updateCar(cars.id, idx)"
                          >
                            Actualizar
                          </el-button>
                          <el-button
                            type="danger"
                            size="mini"
                            round
                            style="width:46%; height: 25px;"
                            icon="el-icon-delete"
                            @click="delCar(cars.number, idx)"
                          >
                            Eliminar
                          </el-button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <el-button
              type="primary"
              size="small"
              @click="presubmit"
              style="background-color: #6a41bdca;"
              >
                Guardar Datos Generales
              </el-button>
            </el-form>
          </el-main>
        </el-container>
      </div>
    </el-col>
  </div>
</template>

<script>
import lodash from 'lodash';
import bathroom from './components/bathroom';
// import Car from './components/car';
import optionsMixin from '../../views/evaluations/SocioEconomic/mixin/options';

export default {
  props: {
    idAppointment: {
      type: Number,
      default: null,
    },
  },
  data() {
    const isDecimal = (rule, value, cb) => {
      const regexp = /^[0-9]+([,.][0-9]+)?$/g;
      if (value && !regexp.test(value)) {
        return cb(new Error('El campo debe ser un numero decimal.'));
      }
      return cb();
    };
    return {
      total: null,
      initialForm: {},
      isFirstEvaluation: null,
      show: true,
      houseRoomsBedroom: false,
      num: null,
      car: [],
      newCars: [],
      numNewCar: 0,
      Placas: [
        {
          value: 'Fronterizo',
          label: 'Fronterizo',
        },
        {
          value: 'Nacional',
          label: 'Nacional',
        },
        {
          value: 'Extranjero',
          label: 'Extranjero',
        },
      ],
      form: {
        patientId: null,
        evaluationId: null,
        motivoEvaluacion: null,
        residenceTimeAtTijuana: null,
        academicDegree: null,
        houseCodition: null,
        houseWalls: null,
        houseFloor: null,
        houseRoof: null,
        houseRoomsLivingRoom: false,
        houseRoomsDiningRoom: false,
        houseRoomsKitchen: false,
        houseRoomsBathroom: null,
        houseRoomsBedroom: 0,
        houseRoomsStudyingRoom: false,
        houseRoomsCourtyard: false,
        houseRoomsOther: false,
        serviceLight: false,
        serviceSewerSystem: false,
        serviceCableTV: false,
        servicePhone: false,
        serviceInternet: false,
        serviceAsphaltStreet: false,
        servicePublicWater: false,
        serviceGaslp: false,
        serviceOther: false,
        houseStuffFridge: false,
        houseStuffStove: false,
        houseStuffMicrowaveOven: false,
        houseStuffBlender: false,
        houseStuffWashingMachine: false,
        houseStuffDryer: false,
        houseStuffComputer: false,
        houseStuffDiningRoomSet: false,
        houseStuffLivingRoomSet: false,
        houseStuffBedroomSet: false,
        houseStuffTV: false,
        houseStuffDishWasher: false,
        car: null,
        expenseWater: null,
        expenseLight: null,
        expensePhone: null,
        expenseCellPhone: null,
        expenseGas: null,
        expenseFood: null,
        expenseHouseSupplies: null,
        expenseHealth: null,
        expenseSupport: null,
        expenseEducation: null,
        expenseRent: null,
        expenseTransport: null,
        expenseCreditCard: null,
        expenseOther: null,
        incomeReceipts: null,
        outcomeReceipts: null,
        familySituationDescription: null,
        comments: null,
        evaluationResult: null,
        programApplied: null,
        cost: null,
        area: null,
        classification: null,
        currency: 'USD',
      },
      rules: {
        expenseWater: [
          {
            validator: isDecimal,
          },
        ],
        expenseLight: [
          {
            validator: isDecimal,
          },
        ],
        expensePhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseCellPhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseGas: [
          {
            validator: isDecimal,
          },
        ],
        expenseFood: [
          {
            validator: isDecimal,
          },
        ],
        expenseHouseSupplies: [
          {
            validator: isDecimal,
          },
        ],
        expenseHealth: [
          {
            validator: isDecimal,
          },
        ],
        expenseSupport: [
          {
            validator: isDecimal,
          },
        ],
        expenseEducation: [
          {
            validator: isDecimal,
          },
        ],
        expenseRent: [
          {
            validator: isDecimal,
          },
        ],
        expenseTransport: [
          {
            validator: isDecimal,
          },
        ],
        expenseCreditCard: [
          {
            validator: isDecimal,
          },
        ],
        expenseOther: [
          {
            validator: isDecimal,
          },
        ],

      },
    };
  },
  mixins: [optionsMixin],
  components: {
    bathroom,
    // Car,
  },
  methods: {
    format() {
      return {
        patient: this.form.patientId,
        evaluationId: this.form.evaluationId,
        motivoEvaluacion: this.form.motivoEvaluacion,
        residenceTimeAtTijuana: this.form.residenceTimeAtTijuana,
        academicDegree: this.form.academicDegree,
        houseCondition: this.form.houseCondition,
        houseWalls: this.form.houseWalls,
        houseFloor: this.form.houseFloor,
        houseRoof: this.form.houseRoof,
        houseRoomsLivingRoom: this.form.houseRoomsLivingRoom,
        houseRoomsDiningRoom: this.form.houseRoomsDiningRoom,
        houseRoomsKitchen: this.form.houseRoomsKitchen,
        houseRoomsBathroom: this.form.houseRoomsBathroom,
        // houseRoomsBathroomQuantity: this.bathroom ? this.form.houseRoomsBathroomQuantity : null,
        houseRoomsBedroom: this.houseRoomsBedroom ? this.form.houseRoomsBedroom : null,
        houseRoomsStudyingRoom: this.form.houseRoomsStudyingRoom,
        houseRoomsCourtyard: this.form.houseRoomsCourtyard,
        houseRoomsOther: this.form.houseRoomsOther,
        serviceLight: this.form.serviceLight,
        serviceSewerSystem: this.form.serviceSewerSystem,
        serviceCableTV: this.form.serviceCableTV,
        servicePhone: this.form.servicePhone,
        serviceInternet: this.form.serviceInternet,
        serviceAsphaltStreet: this.form.serviceAsphaltStreet,
        servicePublicWater: this.form.servicePublicWater,
        serviceGaslp: this.form.serviceGaslp,
        serviceOther: this.form.serviceOther,
        houseStuffFridge: this.form.houseStuffFridge,
        houseStuffStove: this.form.houseStuffStove,
        houseStuffMicrowaveOven: this.form.houseStuffMicrowaveOven,
        houseStuffBlender: this.form.houseStuffBlender,
        houseStuffWashingMachine: this.form.houseStuffWashingMachine,
        houseStuffDryer: this.form.houseStuffDryer,
        houseStuffComputer: this.form.houseStuffComputer,
        houseStuffDiningRoomSet: this.form.houseStuffDiningRoomSet,
        houseStuffLivingRoomSet: this.form.houseStuffLivingRoomSet,
        houseStuffBedroomSet: this.form.houseStuffBedroomSet,
        houseStuffTV: this.form.houseStuffTV,
        houseStuffDishWasher: this.form.houseStuffDishWasher,
        car: this.form.car,
        expenseWater: parseFloat(this.form.expenseWater),
        expenseLight: parseFloat(this.form.expenseLight),
        expensePhone: parseFloat(this.form.expensePhone),
        expenseCellPhone: parseFloat(this.form.expenseCellPhone),
        expenseGas: parseFloat(this.form.expenseGas),
        expenseFood: parseFloat(this.form.expenseFood),
        expenseHouseSupplies: parseFloat(this.form.expenseHouseSupplies),
        expenseHealth: parseFloat(this.form.expenseHealth),
        expenseSupport: parseFloat(this.form.expenseSupport),
        expenseEducation: parseFloat(this.form.expenseEducation),
        expenseRent: parseFloat(this.form.expenseRent),
        expenseTransport: parseFloat(this.form.expenseTransport),
        expenseCreditCard: parseFloat(this.form.expenseCreditCard),
        expenseOther: parseFloat(this.form.expenseOther),
        incomeReceipts: this.form.incomeReceipts,
        outcomeReceipts: this.form.outcomeReceipts,
        familySituationDescription: this.form.familySituationDescription,
        comments: this.form.comments,
        evaluationResult: this.form.evaluationResult,
        programApplied: this.form.evaluationResult === this.evaluationResult[1].value
          ? this.form.programApplied : null,
        cost: this.form.cost,
        classification: this.form.classification,
        currency: this.form.currency,
        area: this.form.area,
      };
    },
    getDiff(obj1 = {}, obj2 = {}, diff = [], keyMap = '') {
      Object.keys(obj1).forEach((key) => {
        if (typeof obj2[key] === 'object' && obj2[key] !== null && !Array.isArray(obj2[key])) {
          const diffR = this.getDiff(obj1[key], obj2[key], diff, `${keyMap}${key}.`);
          diff.concat(diffR);
        } else if (!lodash.isEqual(obj1[key], obj2[key])) {
          let keyMapFormatted = `${keyMap}${key}`;
          keyMapFormatted = keyMapFormatted.replace(/[0-9]$/g, '');
          keyMapFormatted = keyMapFormatted[keyMapFormatted.length - 1] === '.'
            ? keyMapFormatted.slice(0, -1) : keyMapFormatted;
          diff.push(keyMapFormatted);
        }
      });
      return diff;
    },
    open(patientId) {
      this.$alert('El paciente no cuenta con una cita previa', 'AVISO', {
        confirmButtonText: 'Crear una cita',
        callback: (action) => {
          if (action === 'confirm') {
            this.$router.push(`/admin/appointments/social/${patientId}`);
          }
          this.$message({
            type: 'info',
            message: `action: ${action}`,
          });
        },
      });
    },
    async getData(patientId) {
      try {
        const response = await this.axios.get(`patient/newsocial/details/${patientId}`);
        if (response.data.appointmentId === this.idAppointment) {
          this.isFirstEvaluation = false;
        } else {
          this.isFirstEvaluation = true;
        }
        if (response.data) {
          const { data } = response;
          this.evaluationId = data.id;
          this.form = data;
          this.createdAt = data?.createdAt;
          await this.getCar();
          const { houseRoomsBedroom } = data;
          this.houseRoomsBedroom = !!houseRoomsBedroom;
          this.form.houseRoomsBedroom = houseRoomsBedroom;

          const formClone = JSON.parse(JSON.stringify(this.form));
          this.initialForm = formClone;
          this.form.patientId = patientId;
        } else if (this.idAppointment.length <= 0) {
          this.open(patientId);
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    addCar(value, numnewcar) {
      const newValue = value + 1;
      const newcar = numnewcar + 1;
      this.num = newValue;
      this.numNewCar = newcar;
      this.car.push({
        number: this.num,
        model: '',
        year: '',
        plates: '',
      });
      this.newCars = this.car.slice(this.car.length - this.numNewCar);
    },
    async saveCar() {
      try {
        this.loading = true;
        const payload = this.newCars;
        const { id: patientId } = this.$route.params;
        const requests = [];
        const idCita = this.idAppointment;
        requests.concat(payload.map((item) => this.axios.post(`patient/newsocial/car/${idCita}/${patientId}`, {
          ...item,
        })));
        if (requests) {
          for (let index = 0; index < this.newCars.length; index++) {
            this.newCars.pop();
          }
          this.numNewCar = 0;
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha agregado evaluación socioeconómica',
          });
          await this.getCar();
          // setTimeout(() => {
          //   this.loading = false;
          //   await this.getCar();
          //   // this.$router.replace('/');
          // }, 1000);
        }
      } catch (error) {
        // console.log('error mounstruoso!!', error);
      }
    },
    async getCar() {
      try {
        const idCita = this.idAppointment;
        const request = await this.axios.get(`patient/newsocial/car/${idCita}`);
        if (request.data) {
          const { data } = request;
          for (let idx = 0; idx < data.length; idx++) {
            this.car[idx] = data[idx];
          }
          this.num = data.length;
        }
      } catch (error) {
        // this.loading = false;
      }
    },
    delCar(index, idx) {
      try {
        const eliminado = this.car.splice(idx, 1);
        if (eliminado[0].id > 0) {
          this.loading = true;
          const carId = eliminado[0].id;
          const request = this.axios.put(`patient/newsocial/deleteCar/${carId}`);
          if (request) {
            this.$notify({
              type: 'success',
              title: '¡Éxito!',
              message: 'Se ha agregado evaluación socioeconómica',
            });
          }
          this.loading = false;
        }
        const encontrar = this.newCars.findIndex((car) => car.number === index);
        if (encontrar >= 0) {
          this.newCars.splice(encontrar, 1);
        }
      } catch (error) {
        this.loading = false;
        // console.log('err', error);
      }
    },
    async updateCar(carId, idx) {
      try {
        this.loading = true;
        const carUpdate = this.car[idx];
        const request = await this.axios.put(`patient/newsocial/update/car/${carId}`, {
          carUpdate,
        });
        if (request.status === 204) {
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha agregado evaluación socioeconómica',
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        // console.error(error);
      }
    },
    async presubmit() {
      try {
        this.loading = true;
        const requests = [];
        const data = this.format();
        const { id: patientId } = this.$route.params;
        if (this.isFirstEvaluation) {
          requests.push(this.axios.post(`patient/newsocial/${patientId}/${this.idAppointment}`,
            data));
          const response = await Promise.all(requests);
          if (response.length) {
            await this.saveCar();
            await this.axios.post(`patient/changelog/${patientId}`, {
              title: 'EVALUACIÓN SOCIOECONÓMICA',
              message: 'Se ha agregado evaluación socioeconómica',
            });
          }
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha agregado evaluación socioeconómica',
          });
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.go(0);
          // }, 1000);
        } else {
          const formDiff = this.getDiff(this.initialForm, this.form);
          let message;
          if (formDiff.length) {
            await this.updateCar();
            requests.push(this.axios.put(`patient/newsocial/${patientId}/${this.idAppointment}`,
              data));
            message = 'Se modificó el perfil socioeconómico';
          }
          const response = await Promise.all(requests);
          if (response.length) {
            await this.saveCar();
            this.axios.post(`patient/changelog/${patientId}`, {
              title: 'EVALUACIÓN SOCIOECONÓMICA',
              message,
            });
            this.$notify({
              type: 'success',
              title: '¡Éxito!',
              message,
            });
          } else {
            this.$notify({
              type: 'success',
              title: '¡Éxito!',
              message: 'Guardado con Éxito',
            });
          }
        }
        // setTimeout(() => {
        //   this.loading = false;
        //   this.$router.go(0);
        // }, 1000);
        await this.getData(patientId);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    const { id } = this.$route.params;
    this.form.patientId = id;
    await this.getData(id);
  },
};
</script>

<style lang="scss">
@import '../../views/evaluations/SocioEconomic/styles/style.scss';
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.addCar-container {
  display: flex;
  flex-direction: row;
  gap: 5px;
}
.container-card-cars {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 12px;
  font-size: 13px;
  input, select {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding:8px;
  }
}

</style>
<style lang="scss" scoped>
@import '../../views/evaluations/SocioEconomic/styles/style-scoped.scss';
</style>
